export default __webpack_public_path__ + "2a5c62898e3c2ec901eb463d4052b66b.png";